import {RouteDefinition} from '../../../routes';
import {ControlListScreen} from './ControlListScreen';
import {ControlEditScreen} from './ControlEditScreen';

export const ControlSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/control/edit',
        component: ControlEditScreen,
    },
    {
        routerLink: '/settings/control/edit/:id',
        component: ControlEditScreen,
    },
    {
        routerLink: '/settings/control',
        component: ControlListScreen,
    },
];
